const displayValue = (value) =>
    value === null || value === undefined || value === ""
        ? "-"
        : value;

export default displayValue;
